// Neeko — Blooming Burst: launches a magical orb that bounces through up to 3 enemies.
// Each successive bounce deals escalating magic damage — the last target hit takes the most.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

const MAX_TARGETS = 3;
// Damage multipliers per bounce: first hit lowest, last hit highest.
const MULTIPLIERS = [0.55, 0.85, 1.4] as const;
const FLAT_BASE = 55;

export const neekoBounceQ: Ability = {
  id: "neekoBounceQ",
  displayName: "Blooming Burst",
  description: "Launches a magical orb that bounces through up to 3 enemies. Each bounce deals more damage than the last.",
  iconId: "NeekoQ",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    return combat.livingUnitsOf(team)
      .sort((a, b) => a.pos.q - b.pos.q)
      .slice(0, MAX_TARGETS)
      .map(u => u.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const stats = effectiveStats(caster);
    const team = caster.team === "player" ? "enemy" : "player";
    const targets = combat.livingUnitsOf(team)
      .sort((a, b) => a.pos.q - b.pos.q)
      .slice(0, MAX_TARGETS);
    if (targets.length === 0) return [];

    return targets.map((target, i) => ({
      target,
      amount: magicDamage(stats.ap * MULTIPLIERS[i] + FLAT_BASE),
      type: "magical" as const,
      suppressPopup: true,
      neekoBounce: true as const,
    }));
  },
};
